import { LogoFastship, LogoStorezigzin, LogoZdelivery, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

import { OptionData, OptionUiSetting, PdpDeliveryType } from '../../../../type/common.type';

interface Props {
  option: OptionData;
  ui_setting?: OptionUiSetting;
}

export const ProductInfo = ({ option, ui_setting }: Props) => {
  const { type, fee } = option.shipping ?? {};
  const displayShippingInfo = option.shipping && type;
  const display_restock_notification_selection = ui_setting?.display_style === 'restock_notification_selection';
  const is_sold_out = (!display_restock_notification_selection && option.stock_status?.is_sold_out) || false;

  return (
    <Container minHeight={displayShippingInfo ? '36px' : undefined}>
      <ProductName>
        <Text variant='Body_15_Medium' v3Color={is_sold_out ? 'gray300' : 'gray900'}>
          {option.name}
        </Text>
        {is_sold_out && (
          <Text variant='Caption_12_SemiBold' v3Color='gray300' style={{ lineHeight: '18px', whiteSpace: 'pre' }}>
            {' '}
            · 품절
          </Text>
        )}
      </ProductName>
      {displayShippingInfo && (
        <ShippingInfo>
          {type === PdpDeliveryType.GENERAL && (
            <Text variant='Caption_12_Medium' v3Color={is_sold_out ? 'gray200' : 'gray500'}>
              일반배송
              {!!fee && (
                <Text variant='Caption_12_Regular' v3Color={is_sold_out ? 'gray200' : 'gray400'} as='span'>
                  {' '}
                  (+배송 {numberWithCommas(fee)}원)
                </Text>
              )}
            </Text>
          )}
          <Opacity is_sold_out={is_sold_out}>
            {type === PdpDeliveryType.FAST && <LogoFastship width={57} height={11} />}
            {type === PdpDeliveryType.ZIGZIN && <LogoZdelivery width={57} height={11} />}
            {type === PdpDeliveryType.VENDOR_FLEX && <LogoStorezigzin width={67} height={11} />}
          </Opacity>
        </ShippingInfo>
      )}
    </Container>
  );
};

const Container = styled.div<{ minHeight?: string }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight}`};
`;

const ProductName = styled.div`
  display: flex;
`;

const ShippingInfo = styled.div`
  margin-top: 4px;
  font-size: 0;
`;

const Opacity = styled.div<{ is_sold_out: boolean }>`
  opacity: ${({ is_sold_out }) => (is_sold_out ? 0.25 : 1)};
`;
